export const isParent = (field) => {
  if (
    ["RadioButton", "CheckBox"].includes(field.element.ElsRecord.Type) &&
    field.element.ElsRecord.IdParent > 0
  ) {
    return true;
  } else {
    return false;
  }
};
